import React, { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

const GeoLandingPage = ({ config }) => {
  useEffect(() => {
    document.title = config.metaTitle;
    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.name = name; document.head.appendChild(el); }
      el.content = content;
    };
    const setOg = (prop, content) => {
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("property", prop); document.head.appendChild(el); }
      el.content = content;
    };
    setMeta("description", config.metaDesc);
    setMeta("keywords", config.keywords);
    setOg("og:title", config.metaTitle);
    setOg("og:description", config.metaDesc);
    let canon = document.querySelector("link[rel='canonical']");
    if (!canon) { canon = document.createElement("link"); canon.rel = "canonical"; document.head.appendChild(canon); }
    canon.href = config.canonical;
  }, [config]);

  return (
    <Box sx={{ maxWidth: 900, mx: "auto", px: 2, py: 4 }}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 2 }}>
        {config.h1}
      </Typography>
      <Typography sx={{ color: "#555", mb: 3, fontSize: "1.05rem", lineHeight: 1.7 }}>
        {config.intro}
      </Typography>

      {/* Primary CTA */}
      <Box sx={{ mb: 4, textAlign: "center" }}>
        <Button
          variant="contained"
          size="large"
          href={config.wlUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ bgcolor: "#e91e8c", "&:hover": { bgcolor: "#c0176e" }, px: 4, py: 1.5, fontSize: "1rem", fontWeight: 700, borderRadius: 2 }}
        >
          {config.ctaText}
        </Button>
      </Box>

      {/* Why section */}
      <Typography variant="h5" component="h2" sx={{ fontWeight: 700, mb: 2 }}>
        {config.whyTitle}
      </Typography>
      <Box component="ul" sx={{ pl: 2, mb: 3 }}>
        {config.whyPoints.map((p, i) => (
          <Box component="li" key={i} sx={{ mb: 1, color: "#444", lineHeight: 1.7 }}>{p}</Box>
        ))}
      </Box>

      {/* FAQ */}
      <Typography variant="h5" component="h2" sx={{ fontWeight: 700, mb: 2 }}>
        Frequently Asked Questions
      </Typography>
      {config.faq.map((item, i) => (
        <Box key={i} sx={{ mb: 2 }}>
          <Typography sx={{ fontWeight: 700 }}>{item.q}</Typography>
          <Typography sx={{ color: "#555" }}>{item.a}</Typography>
        </Box>
      ))}

      {/* Internal link to category */}
      <Box sx={{ mt: 4, pt: 3, borderTop: "1px solid #eee" }}>
        <Typography sx={{ color: "#555" }}>
          Looking for more options?{" "}
          <Link to={config.categoryLink} style={{ color: "#e91e8c", fontWeight: 600 }}>
            {config.categoryLinkText}
          </Link>{" "}
          — browse all sources including LiveJasmin, SinParty, and Stripchat models.
        </Typography>
      </Box>
    </Box>
  );
};

export default GeoLandingPage;
